export enum VenueTableFilterTypes {
  Status = "status",
  CountryCode = "countryCode",
}
